import enCommon from '@shared/i18n/locales/en/common.json';
import enDashboard from '@shared/i18n/locales/en/dashboard.json';
import enEmpty from '@shared/i18n/locales/en/empty.json';
import enFitAnalysis from '@shared/i18n/locales/en/fit-analysis.json';
import enLogin from '@shared/i18n/locales/en/login.json';
import enMyPage from '@shared/i18n/locales/en/myPage.json';
import enNavigation from '@shared/i18n/locales/en/navigation.json';
import enOnboarding from '@shared/i18n/locales/en/onboarding.json';
import enRoadmap from '@shared/i18n/locales/en/roadmap.json';
import enTermsAgreement from '@shared/i18n/locales/en/termsAgreement.json';
import enTodo from '@shared/i18n/locales/en/todo.json';
import enUserPopover from '@shared/i18n/locales/en/user-popover.json';
import koCommon from '@shared/i18n/locales/ko/common.json';
import koDashboard from '@shared/i18n/locales/ko/dashboard.json';
import koEmpty from '@shared/i18n/locales/ko/empty.json';
import koFitAnalysis from '@shared/i18n/locales/ko/fit-analysis.json';
import koLogin from '@shared/i18n/locales/ko/login.json';
import koMyPage from '@shared/i18n/locales/ko/myPage.json';
import koNavigation from '@shared/i18n/locales/ko/navigation.json';
import koOnboarding from '@shared/i18n/locales/ko/onboarding.json';
import koRoadmap from '@shared/i18n/locales/ko/roadmap.json';
import koTermsAgreement from '@shared/i18n/locales/ko/termsAgreement.json';
import koTodo from '@shared/i18n/locales/ko/todo.json';
import koUserPopover from '@shared/i18n/locales/ko/user-popover.json';
import viCommon from '@shared/i18n/locales/vi/common.json';
import viDashboard from '@shared/i18n/locales/vi/dashboard.json';
import viEmpty from '@shared/i18n/locales/vi/empty.json';
import viFitAnalysis from '@shared/i18n/locales/vi/fit-analysis.json';
import viLogin from '@shared/i18n/locales/vi/login.json';
import viMyPage from '@shared/i18n/locales/vi/myPage.json';
import viNavigation from '@shared/i18n/locales/vi/navigation.json';
import viOnboarding from '@shared/i18n/locales/vi/onboarding.json';
import viRoadmap from '@shared/i18n/locales/vi/roadmap.json';
import viTermsAgreement from '@shared/i18n/locales/vi/termsAgreement.json';
import viTodo from '@shared/i18n/locales/vi/todo.json';
import viUserPopover from '@shared/i18n/locales/vi/user-popover.json';
import zhCnCommon from '@shared/i18n/locales/zh-CN/common.json';
import zhCnDashboard from '@shared/i18n/locales/zh-CN/dashboard.json';
import zhCnEmpty from '@shared/i18n/locales/zh-CN/empty.json';
import zhCnFitAnalysis from '@shared/i18n/locales/zh-CN/fit-analysis.json';
import zhCnLogin from '@shared/i18n/locales/zh-CN/login.json';
import zhCnMyPage from '@shared/i18n/locales/zh-CN/myPage.json';
import zhCnNavigation from '@shared/i18n/locales/zh-CN/navigation.json';
import zhCnOnboarding from '@shared/i18n/locales/zh-CN/onboarding.json';
import zhCnRoadmap from '@shared/i18n/locales/zh-CN/roadmap.json';
import zhCnTermsAgreement from '@shared/i18n/locales/zh-CN/termsAgreement.json';
import zhCnTodo from '@shared/i18n/locales/zh-CN/todo.json';
import zhCnUserPopover from '@shared/i18n/locales/zh-CN/user-popover.json';

export const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    login: enLogin,
    onboarding: enOnboarding,
    todo: enTodo,
    empty: enEmpty,
    dashboard: enDashboard,
    fitAnalysis: enFitAnalysis,
    roadmap: enRoadmap,
    termsAgreement: enTermsAgreement,
    userPopover: enUserPopover,
    myPage: enMyPage,
  },
  ko: {
    common: koCommon,
    navigation: koNavigation,
    login: koLogin,
    onboarding: koOnboarding,
    todo: koTodo,
    empty: koEmpty,
    dashboard: koDashboard,
    fitAnalysis: koFitAnalysis,
    roadmap: koRoadmap,
    termsAgreement: koTermsAgreement,
    userPopover: koUserPopover,
    myPage: koMyPage,
  },
  vi: {
    common: viCommon,
    navigation: viNavigation,
    login: viLogin,
    onboarding: viOnboarding,
    todo: viTodo,
    empty: viEmpty,
    dashboard: viDashboard,
    fitAnalysis: viFitAnalysis,
    roadmap: viRoadmap,
    termsAgreement: viTermsAgreement,
    userPopover: viUserPopover,
    myPage: viMyPage,
  },
  'zh-CN': {
    common: zhCnCommon,
    navigation: zhCnNavigation,
    login: zhCnLogin,
    onboarding: zhCnOnboarding,
    todo: zhCnTodo,
    empty: zhCnEmpty,
    dashboard: zhCnDashboard,
    fitAnalysis: zhCnFitAnalysis,
    roadmap: zhCnRoadmap,
    termsAgreement: zhCnTermsAgreement,
    userPopover: zhCnUserPopover,
    myPage: zhCnMyPage,
  },
} as const;
